
import { END_POINTS } from "../../constants/url";
import { get, post, put } from "../../utils/AxiosMethods"

export const Getcouponcode = async ({ limit, search, page, status, startDate, endDate }: { limit: number; page: number; search: string; status?: string; startDate?: string; endDate?: string }) => {
    try {
        let url = `${END_POINTS.getcouponcode}?limit=${limit}&page=${page}&coupon_code=${search}`;
        if (status) url += `&status=${status}`;
        if (startDate) url += `&startDate=${startDate}`;
        if (endDate) url += `&endDate=${endDate}`;
        const response = await get(url);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const Createcouponcode = async (body: any) => {
    try {
        const response = await post(END_POINTS.createCouponCode, body);
        return response;
    } catch (error) {
        return error;
    }
}
export const Editcouponcode = async (body: any) => {
    try {
        const response = await put(END_POINTS.editCouponCode, body);
        return response;
    } catch (error) {
        console.log(error);
    }
}

export const GetCouponStats = async (id: string) => {
    try {
        const response = await get(`${END_POINTS.couponStats}/${id}`);
        return response;
    } catch (error) {
        console.log(error);
    }
}
